import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { TransitionMode, TransitionDirection } from '@/store/modules/transitions';
import { Route } from 'vue-router';
import { tRoute } from '../plugins/i18nRoutes';
import { RouteNames } from '../router/router.models';

const transitionsModule = namespace('transitions');

Component.registerHooks(['beforeRouteLeave']);

@Component({})
export default class PageTransitionMode extends Vue {
  @transitionsModule.Action public setNavigationType!: (navigation: {
    to: Route;
    from: Route;
  }) => Promise<{
    mode: TransitionMode;
    direction: TransitionDirection;
  }>;

  public async beforeRouteLeave(to: Route, from: Route, next: (value?: boolean) => void) {
    if (to.name === tRoute(RouteNames.Home).name && this.$store.state.configuration.houseConfiguration) {
      try {
        await this.$store.dispatch('notify/openInfoModal', {
          headline: this.$t('global.dialogs.leaveConfiguration.headline'),
          message: this.$t('global.dialogs.leaveConfiguration.message'),
          declineCta: this.$t('global.dialogs.leaveConfiguration.declineCta'),
          acceptCta: this.$t('global.dialogs.leaveConfiguration.acceptCta')
        });

        this.processLeaveRoute(to, from, next);
      } catch (error) {
        next(false);
      }
    } else {
      this.processLeaveRoute(to, from, next);
    }
  }

  public processLeaveRoute(to: Route, from: Route, next: (value?: boolean) => void) {
    this.setNavigationType({ to, from }).then(() => {
      this.$emit('before-route-leave');

      next();
    });
  }
}
